import { nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';

@customElement('lib-combobox-option')
export class LibComboBoxOption extends LibElement {
  static override readonly styles = [LibElement.hostStyles];
  @property({ reflect: true }) value = '';

  override render() {
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap { 'lib-combobox-option': LibComboBoxOption; }
}
